<template>
  <div class="insights-help mx-2">
    <v-tooltip top>
      <template #activator="{ on, attrs }">
        <v-icon
          v-bind="attrs"
          small
          color="primary"
          v-on="on"
          @click="showModal = true"
        >
          help
        </v-icon>
      </template>
      <span>Click for more information</span>
    </v-tooltip>
    <insights-help-modal :open.sync="showModal" />
  </div>
</template>

<script>
import InsightsHelpModal from './InsightsHelpModal';

export default {
  name: 'InsightsHelp',
  components: { InsightsHelpModal },
  data: () => ({ showModal: false }),
};
</script>

<style lang="scss" scoped>
.insights-help {
  margin-bottom: 3px;
}
</style>
